<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Recuperar Arquivo"></fccTitlePage>
      <div class="row">
        <div class="col-sm-2">
          <fcc-spi v-model="spiSelecionado" @change="cpf = ''"></fcc-spi>
        </div>
        <div class="col-sm-3" v-if="spiSelecionado">
          <fcc-select
            placeholder="Selecione o repositório"
            labelField="nome"
            :clearable="false"
            v-model="tiporepositorio"
            :options="listagemGestaoArquivo"
            required
          >
            Selecione o repositório
          </fcc-select>
        </div>
        <div class="col-sm-2" v-if="spiSelecionado && tiporepositorio.tipoarquivo">
          <fcc-input v-model="tipoarquivo">Tipo de arquivo</fcc-input>
        </div>
        <div class="col-sm-3" v-if="tiporepositorio">
          <fcc-input v-model="cpf" v-mask="'###.###.###-##'" @input="validandoCPF(cpf)"
            >CPF
          </fcc-input>
        </div>
        <div class="col-sm-3" v-if="validaBotao">
          <fcc-button @click="listaArquivosCandidato"> Buscar</fcc-button>
        </div>
      </div>
      <a class="d-none" ref="dwld" :href="downloadLink" download></a>
      <fcc-modal
        centered
        id-modal="modal-arquvios-up"
        title-modal="Enviando arquivos"
        esconde-footer
        trava-esc
        size="lg"
        trava-back
      >
        <b-form @submit.prevent="enviarArquivos" autocomplete="off">
          <div class="row">
            <div class="col-4">
              <fcc-spi v-model="spiSelecionado" @change="cpf = ''"></fcc-spi>
            </div>
            <div class="col-4">
              <fcc-input v-model="cpf" v-mask="'###.###.###-##'">CPF </fcc-input>
            </div>
            <div class="col-4">
              <fcc-input v-model="tipoarquivo" required>Tipo de arquivo</fcc-input>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <b-form-file
                placeholder="Arquivos..."
                multiple
                v-model="fileForm"
                required
              ></b-form-file>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </b-form>
      </fcc-modal>
      <fcc-modal
        centered
        id-modal="modal-edit-imagem"
        size="lg"
        title-modal="Arquivo"
        esconde-footer
        trava-esc
        trava-back
      >
        <object>
          <embed type="text/html" width="100%" :src="arquivoSga" style="height: 80vh" />
        </object>
      </fcc-modal>
      <div class="row mt-3" v-if="spiSelecionado">
        <div class="col-sm-12">
          <fcc-table
            striped
            hover
            responsive
            :fields="fieldsTabela"
            :por-page="'100'"
            search
            pagination
            :actions="actionsVisualizar"
            field-visibility
            pdf
            xls
            csv
            title-page="Recuperar Arquivo"
            title-p-d-f="Recuperar Arquivo"
            :items="lstArquivos"
            :optionsButton="optionSolicitacoes"
            @row-selected="selecionaDependencias"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccButton from 'pkgfe.fccbase/componentsBootstrap/fccButton/fccButton.vue'
export default {
  components: { fccButton },
  data() {
    return {
      spiSelecionado: '',
      cpf: '',
      tipoarquivo: 0,
      tiporepositorio: '',
      mostraTabela: false,
      baseUrlSga: store.state.baseUrlSga,
      validaBotao: false,
      fileForm: [],
      dependciaSelecionada: [],
      lstArquivos: [],
      arquivoSga: '',
      downloadLink: '',
      actionsVisualizar: [
        {
          button: true,
          funcaoButton: 'DownloadArquivoBase64',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionSolicitacoes: [
        {
          funcaoButton: 'visualizaArquivo',
          text: 'Download arquivos',
          tooltip: 'Download arquivos',
          variant: 'primary',
          icon: 'download',
          objpermCodigo: store.state.permissaoMenu.alterar
        },
        {
          funcaoButton: 'abreModal',
          text: 'Enviar arquivos',
          tooltip: 'Enviar arquivos',
          variant: 'primary',
          icon: 'upload',
          objpermCodigo: store.state.permissaoMenu.alterar
        }
      ],
      fieldsTabela: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'arqid', label: 'Código', sortable: true, active: true },
        { key: 'arqnomeoriginalarquivo', label: 'Nome arquivo', sortable: true, active: true },

        { key: 'actions', label: '', active: true }
      ],
      listagemGestaoArquivo: [
        {
          id: 1,
          nome: 'Backup',
          arqcodext: 'FICHA_INSCRICAO_FORMULARIO',
          idexterno: '_',
          tipoarquivo: false
        },
        {
          id: 6,
          nome: 'Novo Backup',
          arqcodext: 'FICHA_INSCRICAO_FORMULARIO',
          idexterno: '_',
          tipoarquivo: true
        },
        {
          id: 2,
          nome: 'Backup Isenção',
          arqcodext: 'FICHA_INSCRICAO_FORMULARIO',
          idexterno: '_',
          tipoarquivo: false
        },
        { id: 3, nome: 'Avaliação', arqcodext: 'ARQ_CANDS', idexterno: '-', tipoarquivo: true },
        {
          id: 4,
          nome: 'Laudo Médico',
          arqcodext: 'LAUDO_MEDICO_FICHA',
          idexterno: '_',
          tipoarquivo: false
        },
        {
          id: 5,
          nome: 'Nome Social',
          arqcodext: 'NOME_SOCIAL_FICHA',
          idexterno: '_',
          tipoarquivo: false
        }
      ]
    }
  },
  methods: {
    abreModal() {
      this.$root.$emit('bv::show::modal', 'modal-arquvios-up')
    },

    selecionaDependencias(itens) {
      this.dependciaSelecionada = itens
    },
    visualizaArquivo() {
      const conta = this.dependciaSelecionada.length
      var contaDowload = 1
      if (conta > 0) {
        this.carregaTexto('Download de arquivo')
        this.DownloadArquivo(this.dependciaSelecionada[0]).then(() => {
          if (contaDowload < conta) {
            this.DownloadArquivo(this.dependciaSelecionada[contaDowload])
          } else {
            this.carregaTexto()
          }
          contaDowload = contaDowload + 1
        })
      }
    },
    validandoCPF(cpf) {
      this.mostraTabela = false
      this.validaBotao = false
      const validaCPF = this.validaCPF(cpf).success
      if (validaCPF != null) {
        this.validaBotao = true
      }
    },
    DownloadArquivo(arq) {
      return new Promise((resolve) => {
        axios
          .get(this.baseUrlSga + 'File/Download?id=' + arq.arqid, {
            headers: this.dadosLoginSession.fccTokenHeaders.headers,
            responseType: 'blob'
          })
          .then((response) => {
            this.$refs.dwld.href = window.URL.createObjectURL(new Blob([response.data]))
            this.$refs.dwld.setAttribute('download', arq.arqnomeoriginalarquivo)
            this.$refs.dwld.click()
            resolve(response)
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      })
    },
    DownloadArquivoBase64: function (_, item) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlSga + 'File/DownloadBase64?id=' + item.arqid, {
          headers: this.dadosLoginSession.fccTokenHeaders.headers
        })
        .then((response) => {
          this.$bvModal.show('modal-edit-imagem')
          this.arquivoSga = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    montaIdExterno(tiporepositorio) {
      const inicio = this.spiSelecionado + tiporepositorio.idexterno + this.removeAcento(this.cpf)
      switch (tiporepositorio.id) {
        case 1:
          return inicio + tiporepositorio.idexterno + 'backup'
        case 2:
          return inicio + tiporepositorio.idexterno + 'backup_isencao'
        case 3:
          return inicio + tiporepositorio.idexterno + this.tipoarquivo
        case 4:
        case 5:
          return inicio
        case 6:
          return inicio + tiporepositorio.idexterno + this.tipoarquivo + '_backup'
        default:
          break
      }
    },
    listaArquivosCandidato() {
      this.carregaTexto('Carregando arquivos')
      this.listandoArquivosCandidato(
        this.tiporepositorio.arqcodext,
        this.dadosLoginSession.fccTokenHeaders,
        this.montaIdExterno(this.tiporepositorio)
      ).then((response) => {
        this.lstArquivos = response ? response : []
        this.mostraTabela = true
        this.carregaTexto()
      })
    },
    listandoArquivosCandidato(arqcadCod, headerToken, idExternoSystem) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            this.baseUrlSga +
              'File/DownloadIdExt?idExt=' +
              idExternoSystem +
              '&codArqCad=' +
              arqcadCod,
            headerToken
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((erro) => {
            reject(erro)
          })
      })
    },
    enviarArquivos: function () {
      this.carregaTexto('Enviando arquivos')
      let idExterno = this.spiSelecionado + '-' + this.removeAcento(this.cpf)
      const arquivo = new FormData()
      let parametros = 'ArqcadCod=ARQ_CANDS'
      parametros += '&ArqIDExterno=' + idExterno + '-' + this.tipoarquivo
      parametros += '&ArqPublico=false'
      this.fileForm.forEach((element) => {
        arquivo.append('files', element)
      })
      axios
        .post(this.baseUrlSga + 'File/Upfiles?' + parametros, arquivo, {
          headers: this.dadosLoginSession.fccTokenHeaders.headers
        })
        .then(() => {
          this.callToast('Sucesso', 'success', 'success')

          this.$root.$emit('bv::hide::modal', 'modal-arquvios-up')
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>
